import { EonSparkVersion } from '@repo/api-gw-sdk';

const EON_SPARK_VERSION_TO_SPARK: Record<EonSparkVersion, string> = {
  [EonSparkVersion.EON_SPARK_VERSION_1_0]: '3.5.1',
};

export function eonSparkVersionLabel(version: EonSparkVersion): string {
  return version;
}

export function eonSparkVersionLabelLong(version: EonSparkVersion): string {
  const spark = EON_SPARK_VERSION_TO_SPARK[version];
  return spark ? `${version}\u2003(Spark ${spark})` : version;
}
